// Generated by generate-host-overrides — DO NOT EDIT
/* eslint-disable */

export interface ServiceIdentity {
  name?: string;
  host?: string;
}

export const SERVICE_IDENTITY: Record<string, ServiceIdentity> = {
  'accountgroup.v1.AccountGroupService': { name: 'account-group', host: 'account-group-api-${ENV}.vendasta-internal.com' },
  'accountgroup.v1.AccountValidationService': { name: 'account-group' },
  'accountgroup.v1.AuxiliaryFieldData': { name: 'account-group' },
  'accountgroup.v1.AuxiliaryFieldSchema': { name: 'account-group' },
  'accountgroup.v1.CategoryMigration': { name: 'account-group' },
  'accountgroup.v1.CompetitorService': { name: 'account-group' },
  'accountgroup.v1.Inference': { name: 'account-group' },
  'accountgroup.v1.Prospecting': { name: 'account-group' },
  'accountgroup.v1.SearchEngineResult': { name: 'account-group' },
  'accountgroupmedia.v1.MediaService': { name: 'account-group-media', host: 'account-group-media-api-${ENV}.apigateway.co' },
  'advertising.v1.Admin': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Adwords': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.AdwordsCredentials': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.AdwordsSettingsService': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Authentication': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Business': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.CallRail': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.CampaignEvents': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.CampaignSettingsService': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.CampaignSuggestions': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Campaigns': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Credentials': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.ExecutiveReport': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Facebook': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.FacebookCredentials': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.FacebookSettingsService': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.HistoricalData': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Linkedin': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.LinkedinCredentials': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.LocalAds': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.LocalAdsSettingsService': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Marchex': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.MarkupService': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Matchcraft': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Microsoft': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.MicrosoftCredentials': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.PartnerConfigService': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.SettingsService': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Stats': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.TaboolaCredentials': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Telmetrics': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.TikTok': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Whatsapp': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'advertising.v1.Xandr': { host: 'digital-advertising-api-${ENV}.apigateway.co' },
  'adwords.v1.Accounts': { name: 'adwords-service' },
  'adwords.v1.Keywords': { name: 'adwords-service' },
  'adwords.v1.Reports': { name: 'adwords-service' },
  'apiyext.v1.ApiService': { name: 'api-yext' },
  'astbe.v1.Asterisk': { host: 'astbe-api-${ENV}.apigateway.co' },
  'atlas.v1.Atlas': { host: 'atlas-api-${ENV}.apigateway.co' },
  'atlas.v1.Languages': { host: 'atlas-api-${ENV}.apigateway.co' },
  'atlas.v1.Pins': { host: 'atlas-api-${ENV}.apigateway.co' },
  'auxiliarydata.v1.AuxiliaryFieldData': { name: 'auxiliary-data' },
  'auxiliarydata.v1.AuxiliaryFieldSchema': { name: 'auxiliary-data' },
  'businesscategories.v1.BusinessCategoryService': { name: 'business-categories' },
  'cloudblue.v1.CloudBlueProviderService': { name: 'cloud-blue' },
  'composer.v1.Composer': { host: 'composer-api-${ENV}.apigateway.co' },
  'conciergeaccounts.v1.ConciergeAccountsService': { name: 'concierge-accounts' },
  'constantcontact.v1.AccountService': { name: 'constant-contact' },
  'constantcontact.v1.CampaignService': { name: 'constant-contact' },
  'contacts.v1.ContactEmailService': { host: 'contacts-api-${ENV}.vendasta-internal.com' },
  'contacts.v1.Contacts': { host: 'contacts-api-${ENV}.vendasta-internal.com' },
  'contacts.v1.UserList': { host: 'contacts-api-${ENV}.vendasta-internal.com' },
  'conversation.v1.ChannelIntegrationService': { host: 'conversation-${ENV}.apigateway.co' },
  'conversation.v1.ConversationAIService': { host: 'conversation-${ENV}.apigateway.co' },
  'conversation.v1.ConversationService': { host: 'conversation-${ENV}.apigateway.co' },
  'conversation.v1.web_chat_widget.WebChatWidget': { host: 'conversation-${ENV}.apigateway.co' },
  'crm.v1.CRMAssociationService': { host: 'crm-${ENV}.apigateway.co' },
  'crm.v1.CRMCompanyService': { host: 'crm-${ENV}.apigateway.co' },
  'crm.v1.CRMCustomObjectService': { host: 'crm-${ENV}.apigateway.co' },
  'crm.v1.CRMCustomObjectTypeService': { host: 'crm-${ENV}.apigateway.co' },
  'crm.v1.CRMFieldSchemaCustomizationService': { host: 'crm-${ENV}.apigateway.co' },
  'crm.v1.CRMFieldSchemaService': { host: 'crm-${ENV}.apigateway.co' },
  'crm.v1.CRMOpportunityService': { host: 'crm-${ENV}.apigateway.co' },
  'crm.v1.CRMService': { host: 'crm-${ENV}.apigateway.co' },
  'crm.v1.Pipelines': { host: 'crm-${ENV}.apigateway.co' },
  'customervoice.v1.CampaignService': { name: 'customer-voice-service' },
  'customervoice.v1.CustomerVoice': { name: 'customer-voice-service' },
  'customervoice.v1.ListingsService': { name: 'customer-voice-service' },
  'customervoice.v1.Twilio': { name: 'customer-voice-service' },
  'datatransfer.v1.DataTransferService': { name: 'data-transfer' },
  'developercenter.v1.DeveloperCenter': { name: 'developer-center' },
  'developertraining.v1.AAmadoraToDoService': { name: 'developer-training' },
  'developertraining.v1.AOlabenjoTodoListService': { name: 'developer-training' },
  'developertraining.v1.ASainiTodoservice': { name: 'developer-training' },
  'developertraining.v1.AZafarToDoService': { name: 'developer-training' },
  'developertraining.v1.AdminLibraryUserService': { name: 'developer-training' },
  'developertraining.v1.BookMasterDataService': { name: 'developer-training' },
  'developertraining.v1.BookTransactionService': { name: 'developer-training' },
  'developertraining.v1.BusinessQA': { name: 'developer-training' },
  'developertraining.v1.CceleokaforToDoService': { name: 'developer-training' },
  'developertraining.v1.CgreewnaldToDo': { name: 'developer-training' },
  'developertraining.v1.FAQBuilderService': { name: 'developer-training' },
  'developertraining.v1.GPTaskService': { name: 'developer-training' },
  'developertraining.v1.HGoyalTaskService': { name: 'developer-training' },
  'developertraining.v1.HalhaidariToDoService': { name: 'developer-training' },
  'developertraining.v1.IAntoshToDoList': { name: 'developer-training' },
  'developertraining.v1.KAlShanoonTaskService': { name: 'developer-training' },
  'developertraining.v1.KOdlandTaskService': { name: 'developer-training' },
  'developertraining.v1.KSinghSandhuTodoService': { name: 'developer-training' },
  'developertraining.v1.MustakimToDoService': { name: 'developer-training' },
  'developertraining.v1.NChaudharyToDoService': { name: 'developer-training' },
  'developertraining.v1.NKToDoService': { name: 'developer-training' },
  'developertraining.v1.NTamrazyanToDoService': { name: 'developer-training' },
  'developertraining.v1.SKillaniToDoService': { name: 'developer-training' },
  'developertraining.v1.SPrajapatiToDoService': { name: 'developer-training' },
  'developertraining.v1.TaskMan': { name: 'developer-training' },
  'developertraining.v1.TaxiUserDataService': { name: 'developer-training' },
  'email.v1.Admin': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.Blocks': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.DisposableEmail': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.Domain': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.Drafts': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.EmailClient': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.EmailEventService': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.EmailService': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.InboundEmailConfigs': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.InboundMessageMappingService': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.InboundMessageService': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.Message': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.PartnerEmailQuotaService': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.Preferences': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.RecipientStatus': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.Send': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.SendGridService': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.Senders': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.SubUser': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.TrackedMessages': { host: 'email-api-${ENV}.apigateway.co' },
  'email.v1.Validation': { host: 'email-api-${ENV}.apigateway.co' },
  'emailbuilder.v1.ContentGeneration': { name: 'email-builder' },
  'emailbuilder.v1.Emails': { name: 'email-builder' },
  'emailbuilder.v1.Templates': { name: 'email-builder' },
  'embeddings.v1.Knowledge': { host: 'embeddings-${ENV}.apigateway.co' },
  'eventbroker.v1.EventBroker': { name: 'event-broker', host: 'event-broker-api-${ENV}.apigateway.co' },
  'executivereport.v1.Configuration': { name: 'executive-report' },
  'executivereport.v1.ExecutiveReport': { name: 'executive-report' },
  'facebook.v1.Facebook': { host: 'facebook-api-${ENV}.apigateway.co' },
  'factualdatatransfer.v1.FactualDataFileService': { name: 'factual-data-transfer' },
  'forms.v1.Forms': { host: 'forms-${ENV}.apigateway.co' },
  'gmb.v1.Account': { name: 'google-my-business' },
  'gmb.v1.BusinessCommunications': { name: 'google-my-business' },
  'gmb.v1.BusinessMessages': { name: 'google-my-business' },
  'gmb.v1.GoogleMyBusinessClientLegacyAPI': { name: 'google-my-business' },
  'gmb.v1.Insights': { name: 'google-my-business' },
  'gmb.v1.InsightsSync': { name: 'google-my-business' },
  'gmb.v1.QuestionAnswer': { name: 'google-my-business' },
  'googleanalytics.v1.Records': { name: 'google-analytics', host: 'google-analytics-api-${ENV}.apigateway.co' },
  'googleanalytics.v1.Views': { name: 'google-analytics', host: 'google-analytics-api-${ENV}.apigateway.co' },
  'googleanalytics.v2.GA4Properties': { name: 'google-analytics', host: 'google-analytics-api-${ENV}.apigateway.co' },
  'googleanalytics.v2.GA4Records': { name: 'google-analytics', host: 'google-analytics-api-${ENV}.apigateway.co' },
  'googleanalytics.v2.Records': { name: 'google-analytics', host: 'google-analytics-api-${ENV}.apigateway.co' },
  'googleanalytics.v2.Stats': { name: 'google-analytics', host: 'google-analytics-api-${ENV}.apigateway.co' },
  'googleanalytics.v2.Views': { name: 'google-analytics', host: 'google-analytics-api-${ENV}.apigateway.co' },
  'googlesearchconsole.v1.Records': { name: 'google-search-console' },
  'googlesearchconsole.v1.Sites': { name: 'google-search-console' },
  'group.v1.GroupService': { host: 'group-api-${ENV}.apigateway.co' },
  'gsuite.v1.CustomerService': { host: 'g-suite-api-${ENV}.apigateway.co' },
  'gsuite.v1.DomainService': { host: 'g-suite-api-${ENV}.apigateway.co' },
  'gsuite.v1.GoogleWorkspaceSuperadmin': { host: 'g-suite-api-${ENV}.apigateway.co' },
  'gsuite.v1.PartnerService': { host: 'g-suite-api-${ENV}.apigateway.co' },
  'gsuite.v1.SubscriptionService': { host: 'g-suite-api-${ENV}.apigateway.co' },
  'gsuite.v1.UserService': { host: 'g-suite-api-${ENV}.apigateway.co' },
  'heimdall.v1.Heimdall': { host: 'heimdall-api-${ENV}.apigateway.co' },
  'heimdall.v2.Heimdall': { host: 'heimdall-api-${ENV}.apigateway.co' },
  'helpcenter.v1.ArticleOperations': { name: 'help-center' },
  'helpcenter.v1.HelpCenter': { name: 'help-center' },
  'iam.v1.IAM': { host: 'iam-api-${ENV}.apigateway.co' },
  'iam.v1.UserIAM': { host: 'iam-api-${ENV}.apigateway.co' },
  'iam.v2.IAM': { host: 'iam-api-${ENV}.apigateway.co' },
  'iam.v2.IAMAdmin': { host: 'iam-api-${ENV}.apigateway.co' },
  'iam.v2.IAMInternal': { host: 'iam-api-${ENV}.apigateway.co' },
  'iam.v2.IAMSSO': { host: 'iam-api-${ENV}.apigateway.co' },
  'iamresources.v1.ResourceOwner': { name: 'iam-resources' },
  'libpostal.v1.LibPostal': { host: 'libpostal-api-${ENV}.apigateway.co' },
  'listing_products.v1.BrandVisibilityService': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_products.v1.Citations': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_products.v1.ListingProductsService': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_products.v1.ListingProfileService': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_products.v1.ListingSourceService': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_products.v1.PartnerSettingsService': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_products.v1.SEOAuditService': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_products.v1.SEOService': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_products.v1.SEOSuggestedKeywordsService': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_products.v1.SuggestionService': { host: 'listing-products-api-${ENV}.apigateway.co' },
  'listing_sync_pro.v1.ListingSyncProService': { host: 'listing-sync-pro-api-${ENV}.apigateway.co' },
  'listingscore.v1.ListingScore': { name: 'listing-score' },
  'listingsearch.v1.SearchAdapter': { name: 'listing-search' },
  'localmarketingindex.v1.GradesService': { name: 'local-marketing-index' },
  'localmarketingindex.v1.IndustryAverageService': { name: 'local-marketing-index' },
  'localmarketingindex.v1.LocalMarketingIndex': { name: 'local-marketing-index' },
  'localmarketingindex.v1.ThirdPartyGradesService': { name: 'local-marketing-index' },
  'login.v1.Login': { name: 'vendasta-login-center' },
  'marketplace_packages.v1.AppPartnerSettings': { host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplace_packages.v1.BuyItNow': { host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplace_packages.v1.MarketplacePackages': { host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplace_packages.v1.MarketplaceStore': { host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplace_packages.v1.ShoppingCartService': { host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceanalytics.v1.PartnerEngagementService': { name: 'marketplace-analytics' },
  'marketplaceapps.v1.Editions': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v1.MarketplaceApps': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v1.Vendor': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.AppPricing': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.AppReportingCodeOverrides': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.BasicInventoryItems': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.Category': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.FulfillmentOrderConfigService': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.Items': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.MarketplaceAppData': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.Partner': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.ProductAuxiliaryFieldData': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'marketplaceapps.v2.ProductAuxiliaryFieldSchema': { name: 'marketplace-apps', host: 'marketplace-apps-api-${ENV}.apigateway.co' },
  'matchcraft.v1.AdPlanner': { host: 'matchcraft-api-${ENV}.apigateway.co' },
  'matchcraft.v1.Advantage': { host: 'matchcraft-api-${ENV}.apigateway.co' },
  'matchcraft.v1.Matchcraft': { host: 'matchcraft-api-${ENV}.apigateway.co' },
  'media.v1.ImageService': { host: 'media-api-${ENV}.apigateway.co' },
  'media.v2.MediaService': { host: 'media-api-${ENV}.apigateway.co' },
  'media.v3.Files': { host: 'media-api-${ENV}.apigateway.co' },
  'meetings.v1.MeetingExternal': { host: 'meetings-${ENV}.apigateway.co' },
  'missioncontrol.v1.MissionControl': { name: 'mission-control', host: 'mission-control-api-${ENV}.apigateway.co' },
  'missioncontrol.v1.MissionControlAdmin': { name: 'mission-control', host: 'mission-control-api-${ENV}.apigateway.co' },
  'missioncontrol.v2.AppMetrics': { name: 'mission-control', host: 'mission-control-api-${ENV}.apigateway.co' },
  'missioncontrol.v2.MissionControl': { name: 'mission-control', host: 'mission-control-api-${ENV}.apigateway.co' },
  'missioncontrol.v2.ServiceLevels': { name: 'mission-control', host: 'mission-control-api-${ENV}.apigateway.co' },
  'missioncontrol.v2.User': { name: 'mission-control', host: 'mission-control-api-${ENV}.apigateway.co' },
  'msoffice.v1.MsOffice': { name: 'ms-office' },
  'msoffice.v1.Partner': { name: 'ms-office' },
  'multilocation.v1.MultiLocation': { name: 'multi-location', host: 'multi-location-api-${ENV}.apigateway.co' },
  'multilocationanalytics.v1.AnalyticsService': { name: 'multi-location-analytics', host: 'multi-location-analytics-api-${ENV}.apigateway.co' },
  'notifications.v1.Notifications': { host: 'notifications-api-${ENV}.apigateway.co' },
  'notifications.v1.NotificationsAdmin': { host: 'notifications-api-${ENV}.apigateway.co' },
  'notifications.v1.NotificationsProvider': { host: 'notifications-api-${ENV}.apigateway.co' },
  'notifications.v1.Unsubscribe': { host: 'notifications-api-${ENV}.apigateway.co' },
  'notifications.v1.legacy.LegacyNotificationPreference': { host: 'notifications-api-${ENV}.apigateway.co' },
  'orderfulfillment.v1.FulfillmentFormSubmissionService': { name: 'order-fulfillment', host: 'order-fulfillment-api-${ENV}.apigateway.co' },
  'orderfulfillment.v1.FulfillmentOrderService': { name: 'order-fulfillment', host: 'order-fulfillment-api-${ENV}.apigateway.co' },
  'orderfulfillment.v1.OrderFulfillmentService': { name: 'order-fulfillment', host: 'order-fulfillment-api-${ENV}.apigateway.co' },
  'partner.v1.AcquisitionDataService': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.Addon': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.BrandingV2Service': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.BusinessCenter': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.CannyService': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.CustomerSurveyService': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.FeatureFlags': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.FreeTrialService': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.GrowthEventService': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.IAM': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.Partner': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.PartnerHealths': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.PartnerLegacy': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.PartnerModelService': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.PartnerSignup': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.PartnerTermsOfService': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.PartnerTrial': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.PartnerUserAgreementTermsOfService': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.PreviewEmailService': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.Rewards': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.Sales': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.Stats': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.SubscriptionTiers': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.TaskManager': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.UserOnboarding': { host: 'partner-api-${ENV}.apigateway.co' },
  'partner.v1.Whitelabel': { host: 'partner-api-${ENV}.apigateway.co' },
  'partnertrudsubscribers.v1.PartnerTrudSubscribers': { name: 'partner-trud-subscribers' },
  'platformusers.v1.PermissionsService': { name: 'platform-users' },
  'platformusers.v1.SMBAssociationsService': { name: 'platform-users' },
  'platformusers.v1.UsersService': { name: 'platform-users' },
  'platformusers.v1.ViewAccessService': { name: 'platform-users' },
  'reputation.v1.ListingService': { host: 'reputation-api-${ENV}.apigateway.co' },
  'reputation.v1.NetPromoterScoreService': { host: 'reputation-api-${ENV}.apigateway.co' },
  'reputation.v1.ReviewService': { host: 'reputation-api-${ENV}.apigateway.co' },
  'sales.v1.BusinessActivity': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.BusinessService': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.CampaignService': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.Contacts': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.ExternalIdentifiers': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.Freshdesk': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.LegacyEvents': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.Meeting': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.PartnerService': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.Sales': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.SalesActivityService': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.SalesTeamService': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.Tasks': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v1.UserActionsProvider': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v2beta1.ActionLists': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v2beta1.BusinessService': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v2beta1.CampaignService': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v2beta1.CancellationRequests': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v2beta1.Contacts': { host: 'sales-api-${ENV}.apigateway.co' },
  'sales.v2beta1.Salespeople': { host: 'sales-api-${ENV}.apigateway.co' },
  'salesopportunities.v1.Goals': { name: 'sales-opportunities' },
  'salesopportunities.v1.OpportunityScoring': { name: 'sales-opportunities' },
  'salesopportunities.v1.SalesOpportunities': { name: 'sales-opportunities' },
  'salesopportunities.v1.SalesPipelines': { name: 'sales-opportunities' },
  'salesopportunities.v1.SalesPipelinesAdmin': { name: 'sales-opportunities' },
  'salesorders.v1.CustomerSalesOrders': { name: 'sales-orders' },
  'salesorders.v1.DeclinedReasons': { name: 'sales-orders' },
  'salesorders.v1.Documents': { name: 'sales-orders' },
  'salesorders.v1.Notifications': { name: 'sales-orders' },
  'salesorders.v1.Public': { name: 'sales-orders' },
  'salesorders.v1.SalesOrders': { name: 'sales-orders', host: 'sales-orders-${ENV}.apigateway.co' },
  'salesorders.v1.SalesOrdersAuxiliaryFieldData': { name: 'sales-orders' },
  'salesorders.v1.SalesOrdersAuxiliaryFieldSchema': { name: 'sales-orders', host: 'sales-orders-${ENV}.apigateway.co' },
  'salesorders.v1.SalesOrdersDevelopment': { name: 'sales-orders' },
  'salesorders.v1.VendorOrders': { name: 'sales-orders' },
  'shoppablefeed.v1.ShoppableFeed': { name: 'shoppable-feed' },
  'snapshot.v1.AIOptimizationSectionService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.AISearchVisibilityAuditService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.AdvertisingSectionService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.ArtificialIntelligence': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.CurrentSnapshot': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.EcommerceSectionService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.ListingSectionService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.ReviewSectionService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.SEOSectionService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.SnapshotLiteService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.SnapshotRecord': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.SnapshotService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.SocialSectionService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.TechnologySectionService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.TechnologyService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshot.v1.WebsiteSectionService': { host: 'snapshot-api-${ENV}.apigateway.co' },
  'snapshotwidget.v1.SnapshotWidgetService': { name: 'snapshot-widget' },
  'socialdrafts.v1.Drafts': { name: 'social-drafts', host: 'social-drafts-api-${ENV}.apigateway.co' },
  'socialposts.v1.BlogWebsite': { name: 'social-posts' },
  'socialposts.v1.GenerateVideo': { name: 'social-posts' },
  'socialposts.v1.HashTags': { name: 'social-posts' },
  'socialposts.v1.ImageGeneration': { name: 'social-posts' },
  'socialposts.v1.ImageLibrary': { name: 'social-posts' },
  'socialposts.v1.MultilocationPostService': { name: 'social-posts' },
  'socialposts.v1.PartnerSocialPosts': { name: 'social-posts' },
  'socialposts.v1.PexelsImages': { name: 'social-posts' },
  'socialposts.v1.PixabayImages': { name: 'social-posts' },
  'socialposts.v1.PostPerformance': { name: 'social-posts' },
  'socialposts.v1.PostTemplates': { name: 'social-posts' },
  'socialposts.v1.SocialContent': { name: 'social-posts' },
  'socialposts.v1.SocialMentions': { name: 'social-posts' },
  'socialposts.v1.SocialPostEngagements': { name: 'social-posts' },
  'socialposts.v1.SocialPosts': { name: 'social-posts', host: 'social-posts-${ENV}.apigateway.co' },
  'socialposts.v1.TenorGifs': { name: 'social-posts' },
  'socialposts.v2.BlogConnectionService': { name: 'social-posts' },
  'socialposts.v2.BlogPostsService': { name: 'social-posts' },
  'socialposts.v2.CampaignService': { name: 'social-posts' },
  'socialposts.v2.ChatBot': { name: 'social-posts' },
  'socialposts.v2.ChatBotV2': { name: 'social-posts' },
  'socialposts.v2.CommonAiInstructions': { name: 'social-posts' },
  'socialposts.v2.ContentGeneration': { name: 'social-posts' },
  'socialposts.v2.CuratedContent': { name: 'social-posts' },
  'socialposts.v2.Drafts': { name: 'social-posts' },
  'socialposts.v2.Linkedin': { name: 'social-posts' },
  'socialposts.v2.Provisioning': { name: 'social-posts' },
  'socialposts.v2.SocialComments': { name: 'social-posts' },
  'socialposts.v2.SocialPostsV2': { name: 'social-posts', host: 'social-posts-${ENV}.apigateway.co' },
  'socialposts.v2.Unsplash': { name: 'social-posts' },
  'socialposts.v2.WordpressPluginService': { name: 'social-posts', host: 'social-posts-${ENV}.apigateway.co' },
  'srereporting.v1.Availability': { name: 'sre-reporting', host: 'sre-reporting-api-${ENV}.apigateway.co' },
  'srereporting.v1.SLOHistory': { name: 'sre-reporting', host: 'sre-reporting-api-${ENV}.apigateway.co' },
  'srereporting.v1.ServiceLevel': { name: 'sre-reporting', host: 'sre-reporting-api-${ENV}.apigateway.co' },
  'srereporting.v1.User': { name: 'sre-reporting', host: 'sre-reporting-api-${ENV}.apigateway.co' },
  'sso.v1.Consent': { host: 'sso-api-${ENV}.apigateway.co' },
  'sso.v1.ConsentAdmin': { host: 'sso-api-${ENV}.apigateway.co' },
  'sso.v1.IdentityProvider': { host: 'sso-api-${ENV}.apigateway.co' },
  'sso.v1.IdentityProviderAdmin': { host: 'sso-api-${ENV}.apigateway.co' },
  'sso.v1.ServiceProvider': { host: 'sso-api-${ENV}.apigateway.co' },
  'sso.v1.ServiceProviderAdmin': { host: 'sso-api-${ENV}.apigateway.co' },
  'task.v1.TaskCommand': { host: 'task-api-${ENV}.apigateway.co' },
  'task.v1.TaskQuery': { host: 'task-api-${ENV}.apigateway.co' },
  'taskmanager.v1.AccountProductDetails': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.Accounts': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.BusinessFulfillmentSettings': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.CustomTags': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.DigitalAgents': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.Group': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.Metrics': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.OrderForm': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.ProductFulfillment': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.ProductFulfillmentSettings': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.RecurringTasks': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.SocialCalendar': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.TaskAuxiliaryFieldData': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.TaskAuxiliaryFieldSchema': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.TaskManager': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.TaskManagerAuth': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.TaskStatuses': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.Templates': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'taskmanager.v1.Vendor': { name: 'task-manager', host: 'task-manager-api-${ENV}.apigateway.co' },
  'templates.v1.TemplatesService': { host: 'templates-api-${ENV}.apigateway.co' },
  'tesseract.v1.Admin': { host: 'tesseract-api-${ENV}.apigateway.co' },
  'tesseract.v1.Tesseract': { host: 'tesseract-api-${ENV}.apigateway.co' },
  'theloop.v1.TheLoop': { name: 'the-loop' },
  'twitter.v1.Twitter': { host: 'twitter-api-${ENV}.apigateway.co' },
  'url_shortener.v1.UrlShortener': { host: 'url-shortener-api-${ENV}.apigateway.co' },
  'vanalytics.v1.VAnalytics': { host: 'vanalytics-${ENV}.apigateway.co' },
  'vendasta.citations.CitationService': { name: 'citations' },
  'vendorwebhooks.v1.VendorWebhooks': { name: 'vendor-webhooks' },
  'web_crawler.v1.CollectorService': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.IncidentService': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.ListingService': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.LockdownService': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.MatchService': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.PlatformHealth': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.RescrapeService': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.ScraperService': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.SearchService': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.SiteCrawl': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'web_crawler.v1.TavilyNamespaceLimitService': { host: 'web-crawler-api-${ENV}.apigateway.co' },
  'wordpress_hosting.v1.PartnerApi': { host: 'websitepro-${ENV}.apigateway.co' },
  'wsp_admin_center.v1.SearchService': { host: 'websitepro-${ENV}.apigateway.co' },
  'wsp_admin_center.v1.WordpressService': { host: 'websitepro-${ENV}.apigateway.co' },
  'wsp_monitor.v1.Monitor': { host: 'websitepro-${ENV}.apigateway.co' },
  'wsp_site_info.v1.Cache': { host: 'websitepro-${ENV}.apigateway.co' },
  'wsp_site_info.v1.SiteInfo': { host: 'websitepro-${ENV}.apigateway.co' },
  'wsp_support_tools.v1.SiteManager': { host: 'websitepro-${ENV}.apigateway.co' },
  'wsp_wp_manager.v1.PageSpeedService': { host: 'websitepro-${ENV}.apigateway.co' },
  'wsp_wp_manager.v1.SiteOptionsService': { host: 'websitepro-${ENV}.apigateway.co' },
  'yext.v1.EntityAdmin': { host: 'yext-api-${ENV}.apigateway.co' },
  'yext.v1.Yext': { host: 'yext-api-${ENV}.apigateway.co' },
};
